import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { countryNameByLocale } from "../locales/locales";
import { EditorGroup } from "./EditorHelpers";
import { EuropeHeaderProps } from "./headerTypes";
import { useRestorable, v } from "../util/useRestorable";
import { PresetTextEditor } from "../components/TextEditor";
import { PresetColorEditor } from "../components/ColorPicker";



interface EuropeHeaderEditorProps {
  onChange: (update: EuropeHeaderProps) => void;
  flyerType: string;
  flyerLocale: string;
}

export default function EuropeHeaderEditor(props: EuropeHeaderEditorProps) {
  const { t } = useTranslation();
  const { onChange, flyerLocale } = props;
  const { t: dt } = useTranslation(null, { lng: flyerLocale.substring(0, 2) })
  const [header1, setHeader1] = useRestorable(dt('default.buy-european.title').toUpperCase(), 'header1');
  const [header2, setHeader2] = useRestorable(dt('default.stronger-europe.title').toUpperCase(), 'header2');
  const [header3, setHeader3] = useRestorable(flyerLocale.endsWith('EU') ? "" : dt('default.stronger-x.title', { x: countryNameByLocale[flyerLocale] }).toUpperCase(), 'header3');
  const [color, setColor] = useRestorable("#003399", 'color');
  const [debouncedChange, setDebouncedChange] = useState<EuropeHeaderProps | null>(null);

  // Debounce changes
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedChange({
        header1: v(header1),
        header2: v(header2),
        header3: v(header3),
        color: v(color),
      });
    }, 250);

    // Cleanup function to clear the timeout
    return () => {
      clearTimeout(handler);
    };
  }, [header1, header2, header3, color]);

  useEffect(() => {
    onChange(debouncedChange)
  }, [debouncedChange]);
  
  return (
    <EditorGroup>
      <PresetTextEditor 
        label={t('header.label')}
        value={header1}
        onChange={setHeader1} 
      />
      <PresetTextEditor 
        value={header2}
        onChange={setHeader2} 
      />
      <PresetTextEditor 
        value={header3}
        onChange={setHeader3} 
      />
      <PresetColorEditor 
        value={color}
        onChange={setColor} 
      />
    </EditorGroup>
  )
}